import Common from '../helpers/Common'
import axios from 'axios';

const hostApi = (Common.isProduction()) ? '' : process.env.VUE_APP_HOST_API; // ..env.local 파일에 설정하고 serve 재시작

const primeAppToken = process.env.VUE_APP_PRIME_APP_TOKEN;

const api = {
    filters: `${hostApi}/api/v1App/getFilters`,

    subscsCount: `${hostApi}/api/v1App/getSubscCount`,
    dealerCdks: `${hostApi}/api/v1App/dealerCdks`,
    dealerAgentCdks: `${hostApi}/api/v1App/dealerAgentCdks`,
    dealerAdvisorCdks: `${hostApi}/api/v1App/dealerAdvisorCdks`,
    pkgs: `${hostApi}/api/v1App/pkgs`,
    subscs: `${hostApi}/api/v1App/subscs`,
    vehicles: `${hostApi}/api/v1App/vehicles`,
    users: `${hostApi}/api/v1App/users`,
    promoLinks: `${hostApi}/api/v1App/promoLinks`,
    careInsuranceConfirms: `${hostApi}/api/v1App/careInsuranceConfirms`,
    recordPayments: `${hostApi}/api/v1App/recordPayments`,
    subscSolicitations: `${hostApi}/api/v1App/subscSolicitations`,

    admin:{
        subscs: `${hostApi}/api/v1/subscs`,
    },

    plus:{
        users: `${hostApi}/api/v1Plus/users`,
    },

    vtg:{
        users: `${hostApi}/api/v1Vtg/users`,
    }
};

function fetchFilters() {
    return axios.get(api.filters);
}

export {
    api,
    hostApi,
    primeAppToken,
    fetchFilters,
    
};
